export default {"src":"/_next/static/media/CheckBoxActive.e09ffdec.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};